import React from 'react';
import { motion } from 'framer-motion';

const credentials = [
  'Amazon Best-Selling Author',
  'National Writers Union Endorsement',
  "Who's Who in America",
  "Who's Who in the World",
];

const roles = [
  { title: 'Editorial Assistant', org: 'Teen Magazine' },
  { title: 'Writer', org: "Georgetown University's Creator Institute" },
  { title: 'Publishing & Media Specialist', org: 'Manuscripts LLC' },
];

const AboutSidebar = () => (
  <motion.aside
    initial={{ opacity: 0, x: 30 }}
    animate={{ opacity: 1, x: 0 }}
    transition={{ delay: 0.4, duration: 0.8 }}
    className="md:col-span-4"
  >
    <div className="sticky top-32 space-y-8">
      <div className="p-8 rounded-2xl bg-pink-soft/50 border border-pink-blush/50">
        <h3 className="text-xl font-serif font-semibold text-brown-deep mb-4">Credentials</h3>
        <ul className="space-y-3 text-sm text-brown-deep">
          {credentials.map((item) => (
            <li key={item} className="flex items-start">
              <span className="text-pink-mauve mr-2">•</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="p-8 rounded-2xl bg-white border border-pink-blush shadow-soft">
        <h3 className="text-xl font-serif font-semibold text-brown-deep mb-4">Current Roles</h3>
        <ul className="space-y-3 text-sm text-brown-deep">
          {roles.map((role, i) => (
            <li key={role.title} className={i < roles.length - 1 ? 'pb-3 border-b border-pink-blush' : ''}>
              <div className="font-medium text-brown-deep">{role.title}</div>
              <div className="text-brown-warm">{role.org}</div>
            </li>
          ))}
        </ul>
      </div>

      <div className="p-8 rounded-2xl bg-lavender-soft/30 border border-pink-blush/50">
        <h3 className="text-xl font-serif font-semibold text-brown-deep mb-4">Education</h3>
        <div className="space-y-2 text-sm text-brown-deep">
          <div className="font-medium text-brown-deep">Political Science</div>
          <div className="text-brown-warm">Middlesex University</div>
        </div>
      </div>
    </div>
  </motion.aside>
);

export default AboutSidebar;
